import { render, staticRenderFns } from "./headerDefault.vue?vue&type=template&id=d29418ae"
import script from "./headerDefault.vue?vue&type=script&lang=js"
export * from "./headerDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroDefault: require('/opt/build/repo/frontend/components/hero/heroDefault.vue').default})
